<template>
  <div class="custom_upload">
    <a-upload
      :multiple="checkFileList.length > 1 ? true : false"
      :withCredentials="true"
      :showUploadList="false"
      :directory="false"
      :accept="accept"
      :file-list="uploadFileList"
      :before-upload="beforeUpload"
      :customRequest="customRequest"
    >
      <div class="btn" @click="getUploadFileOperationKey">
        <slot></slot>
      </div>
    </a-upload>
    <ConfirmModal
      @confirm="addIrc"
      @cancel="removeIrc"
      title="添加字幕"
      contentTxt="不同名文件名将被自动修改为与音频同名，原有字幕文件将被替换"
      ref="replaceIcrModalRef"
    ></ConfirmModal>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import uploadManager from './methods/uploadManager';
import ConfirmModal from '../common/ConfirmModal.vue';
import { getFileName } from '../../utils/utils';

export default {
  components: { ConfirmModal },
  props: {
    accept: {
      type: String,
      default: '.lrc',
    },
    // multiple: {
    //   type: Boolean,
    //   default: true,
    // },
    columnKey: {
      type: String,
      default: 'defaultColumnKey',
    },
    checkFileList: {
      // 要操作的文件类型
      type: Array,
    },
  },
  setup(props, context) {
    const uploadFileList = ref([]); // 上传文件的列表
    const operationKey = ref(''); // 操作key
    const store = useStore();
    const replaceIcrModalRef = ref(null);
    function toggleReplaceModal(status) {
      replaceIcrModalRef.value.toggleModal(status);
    }
    function getUploadedAudio() {
      const uploadedAudio = {};
      props.checkFileList.forEach(file => {
        uploadedAudio[getFileName(file.title)] = file;
      });
      return uploadedAudio;
    }
    function getChooseArticleKeys() {
      const articleKeys = [];
      props.checkFileList.forEach(file => {
        articleKeys.push(file.key);
      });
      return articleKeys;
    }
    // 上传成功之后刷新页面和用户信息数据
    function refresh() {
      store.dispatch('getUserInfo');
      context.emit('update');
    }
    const handleStatus = {
      Init: 0,
      Handled: 1,
    };
    let fileList = [];
    // 上传前的处理
    const beforeUpload = (file, list) => {
      if (fileList.length === 0) {
        // 多个文件时只执行一次beforeUpload的方法
        fileList = list;
        toggleReplaceModal(true);
      }
      return false;
    };
    // 自定义上传动作
    const customRequest = () => {
      // uploadManager.startUpload();
    };
    // 确认弹框点击确定
    function addIrc() {
      toggleReplaceModal(false);
      // customRequest();
      if (operationKey.value === handleStatus.Init) {
        uploadManager.beforeUpload({
          fileList,
          uploadedAudio: getUploadedAudio(),
          params: {
            articleKeys: getChooseArticleKeys(),
            columnKey: props.columnKey,
          },
          type: 'batchUploadLRC',
          callback: refresh,
        });
      }
      fileList = [];
      operationKey.value = handleStatus.Handled;
    }
    // 确认弹框点击取消
    function removeIrc() {
      fileList = [];
      toggleReplaceModal(false);
      uploadManager.clearOperationData(operationKey.value);
    }

    // 点击上传按钮:生成新的key,是添加字幕时处理已选音频
    function getUploadFileOperationKey() {
      operationKey.value = handleStatus.Init;
    }
    return {
      getUploadFileOperationKey,
      uploadFileList,
      beforeUpload,
      customRequest,
      replaceIcrModalRef,
      addIrc,
      removeIrc,
    };
  },
};
</script>
